export default "__VITE_ASSET__iNR60CR$__"